module.exports = __webpack_public_path__ + "img/chatduell1.5a3af02b.webp";